import React from 'react'
import ReactDOM from 'react-dom'
import './my-integral.less'
import { ListView, Toast, ActivityIndicator, Result } from 'antd-mobile'
import { fetchIntegral, fetchCheckIn } from '@/api/my-integral'
import { setHeader } from '@/util/set-header'

const Footer = ({ isLoading, isHasMore, dataSource }: any) => {
    if (isHasMore) {
        if (dataSource._cachedRowCount > 0) {
            return <div className="text-center">没有更多啦</div>
        } else {
            return (
                <Result
                    img={<img src="/public/assets/img/error.png" alt="" />}
                    message={<div>暂无积分哦</div>}
                />
            )
        }
    }
    return (
        <div className="flex-lvc">
            {isLoading ? <ActivityIndicator text="加载中..." /> : ''}
        </div>
    )
}

export default class MyIntegral extends React.Component<any, any> {
    el!: ListView
    rData: any = []
    sectionIDs = ['0']
    rowIDs: any = [[]]
    dataBlobs: any = {}

    constructor(props: any) {
        super(props)

        const getRowData = (dataBlob: any, sectionID: any, rowID: any) => dataBlob[rowID]

        const dataSource = new ListView.DataSource({
            getRowData,
            rowHasChanged: (row1: any, row2: any) => row1 !== row2,
            sectionHeaderHasChanged: (s1: any, s2: any) => s1 !== s2
        })

        this.state = {
            dataSource,
            isLoading: true,
            min_id: '0',
            is_end: false,
            now_integral: '0',
            sign_in_state: '签到',
            height: document.documentElement.clientHeight * 3 / 4
        }

        ; (window as any).signInSuccess = () => {
            Toast.show('签到成功')
            this.onRefresh()
            this.signInData()
        }
    }

    UNSAFE_componentWillMount() {
        setHeader({
            title: '我的积分',
            leftClick: this.leftClick,
            className: 'toolbar'
        })
    }

    leftClick() {
        //返回App
        if (window.WebViewBridge) {
            window.WebViewBridge.navBackMarket()
        } else if (window.webkit) {
            window.webkit.messageHandlers.navBackMarket.postMessage('')
        }
    }

    componentDidMount() {
        const hei = document.documentElement.clientHeight -
            (ReactDOM.findDOMNode(this.el) as any).getBoundingClientRect().top
        this.signInData()
        this.genData('0')
        this.setState({
            height: hei,
        })
    }

    /**
     * 签到数据
     */
    signInData = async () => {
        const { data } = await fetchCheckIn()
        this.setState({
            sign_in_state: data.is_today_signed ? '已签到' : '签到'
        })  
    }

    /**
     * 积分数据
     */
    genData = async (min_id: string) => {
        const { data } = await fetchIntegral(min_id)
        if (data.code !== 'SUCCESS') {
            Toast.show(data.msg)
            return
        }
        const pointList = data.data
        for (let i = 0; i < pointList.length; i++) {
            let { id } = pointList[i]
            this.rowIDs[0].push(id)
            this.dataBlobs[id] = pointList[i]
        }
        this.setState({
            dataSource: this.state.dataSource.cloneWithRowsAndSections(
                this.dataBlobs,
                this.sectionIDs,
                this.rowIDs,
            ),
            isLoading: false,
            min_id: data.min_id,
            is_end: data.is_end,
            now_integral: data.now_integral,
        })
    }

    /**
     * 刷新数据
     */
    onRefresh = async () => {
        this.rowIDs = [[]]
        this.dataBlobs = {}
        this.genData('0')
      }

    /**
     * 加载更多
     */
    onEndReached = () => {
        if (this.state.isLoading || this.state.is_end) {
            return
        }
        this.setState({ isLoading: true })
        this.genData(this.state.min_id)
    }

    /**
     * 签到
     */
    signIn = () => {
        if (window.WebViewBridge) {
            window.WebViewBridge.signIn && window.WebViewBridge.signIn()
        } else if (window.webkit) {
            window.webkit.messageHandlers.signIn.postMessage(null)
        }
    }

    /**
     * 赚积分
     */
    earnPoints = () => {
        const { history } = this.props
        history.push(`/earn-point`)
    }

    render() {
        const header = () => {
            return (
                <div className="item-header">消费明细</div>
            )
        }

        const item = (item: any) => {
            return (
                <div key={item.id} className="item-point">
                    <div className="top">
                        <div>{item.remark}</div>
                        <div>{item.number}</div>
                    </div>
                    <div className="bottom">
                        <div>{item.create_time}</div>
                        <div>{item.integral}</div>
                    </div>
                    <div className="line"></div>
                </div>
            )
        }

        return (
            <div className="my-integral">
                <div className="header">
                    <div className="integral">{this.state.now_integral}</div>
                    <div className="sign-in">
                        <div className="left" onClick={this.signIn}>{this.state.sign_in_state}</div>
                        <div className="left" onClick={this.earnPoints}>赚积分</div>
                    </div>
                </div>
                <ListView
                    className="point-listView"
                    ref={(el: any) => (this.el = el)}
                    dataSource={this.state.dataSource}
                    renderHeader={header}
                    renderFooter={() => (
                        <Footer
                            isLoading={this.state.isLoading}
                            isHasMore={this.state.is_end}
                            dataSource={this.state.dataSource}
                        />
                    )}
                    renderRow={item}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                    }}
                    pageSize={10}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                />
            </div>
        )
    }
}